import { createClient } from '@supabase/supabase-js'

let supabase

export function initSupabaseClient() {
  if (!supabase) {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
    const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY
    if (!supabaseUrl || !supabaseKey) {
      throw new Error('Missing Supabase URL or Anon Key')
    }
    supabase = createClient(supabaseUrl, supabaseKey, {
      auth: {
        persistSession: true,
        detectSessionInUrl: true
      }
    })
  }
  return supabase
}

// Export the supabase client for direct use
export { supabase }

export async function signIn(email, password) {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) {
      return { data: null, error }
    }
    return { data, error: null }
  } catch (error) {
    return { data: null, error }
  }
}

export async function signOut() {
  try {
    const { error } = await supabase.auth.signOut()
    if (error) {
      return { error }
    }
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export async function getCurrentUser() {
  try {
    const { data, error } = await supabase.auth.getUser()
    if (error) {
      return { data: null, error }
    }
    return { data, error: null }
  } catch (error) {
    return { data: null, error }
  }
}

export function onAuthStateChange(callback) {
  const { data: subscription } = supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session)
  })
  return () => {
    subscription?.unsubscribe()
  }
}

const ALLOWED_OPERATORS = new Set([
  'eq', 'neq', 'lt', 'lte', 'gt', 'gte', 'like', 'ilike',
  'in', 'is', 'contains', 'containedBy', 'rangeLt', 'rangeGt',
  'rangeGte', 'rangeLte', 'rangeAdjacent', 'overlaps', 'textSearch'
])

export async function query(table, filters = []) {
  let qb = supabase.from(table).select('*')
  if (Array.isArray(filters)) {
    filters.forEach(({ field, operator = 'eq', value }) => {
      if (ALLOWED_OPERATORS.has(operator) && typeof qb[operator] === 'function') {
        qb = qb[operator](field, value)
      } else {
        console.warn(`Unsupported operator "${operator}" on field "${field}"`)
      }
    })
  } else if (filters && typeof filters === 'object') {
    Object.entries(filters).forEach(([field, value]) => {
      qb = qb.eq(field, value)
    })
  }
  const { data, error } = await qb
  return { data, error }
}